import { wallAttachmentsAPI } from '@/lib/api';

export const fileSize = bytes => bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} Mo` : `${Math.max(1, Math.ceil(bytes / 1024))} Ko`;

export async function downloadWallFile(prospectId, file, signal, client = wallAttachmentsAPI) {
    const { data } = await client.download(prospectId, file.id, signal);
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.dataset.testid = `wall-file-save-${file.id}`;
    link.href = url; link.download = file.filename;
    document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}